import {
	WeaTools
} from 'ecCom'

export const getTableEditInfo = (params) => {
	return WeaTools.callApi('/api/hrm/password/getPasswordQuestion', 'POST', params);
}

export const isSecutitySetting = (params) => {
	return WeaTools.callApi('/api/hrm/password/isSettedQuestion', 'GET', params);
}

export const securityQaSave = (params) => {
	return WeaTools.callApi('/api/hrm/password/insertQuestion', 'POST', params);
}

export const setSecSettingStatus = (params) => {
	return WeaTools.callApi('/api/hrm/password/changePswSwitch', 'POST', params);
}

export const isOpenSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/isOpenSecondaryPwd', 'GET', params);
}

export const hrmOffline = (params={}) => {
	return WeaTools.callApi('/api/hrm/common/hrmOffline', 'POST', params);
}

export const isWeakPassword = (params = {}) => WeaTools.callApi('/api/hrm/password/isWeakPassword', 'POST', params)


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/password.js